<style lang="less" scoped>
@import '@/style/index.less';
.redeem-info{
  .overdue-detail{
    border-bottom: 1px #ccc solid;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }
}
</style>

<template>
  <div class="redeem-info local-main-page" >
    <OverdueDetail v-if="overdueRecordId" :id="overdueRecordId" :module="['contract', 'customer', 'vehicle', 'overdue', 'collection', 'letter']" />
    <FlowEdit ref="flow-edit" :mainData="mainData" :flow="flow.data" :disabled="isFinished" :payload="{ id: currentParams.overdueRecordOrFlowId }" @back="onBack" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import FlowEdit from '@/components/data/FlowEdit.vue'
import vehicleApi from '@/pages/index/api/vehicle'
import { getFileWithPromise } from '@/pages/index/utils/file'
import OverdueDetail from '@/pages/index/components/OverdueDetail.vue'
import { simpleDecrypt } from '@/config/utils'
import redeemFlowConfig from '../redeemFlowConfig'
import mainData from '../mainData'
import { promiseAllFinished } from 'complex-utils'

let fromPath = ''

export default defineComponent({
  name: 'RedeemInfo',
  components: {
    OverdueDetail,
    FlowEdit
  },
  data() {
    return {
      mainData,
      detail: undefined as undefined | Record<string, any>,
      flow: {
        data: redeemFlowConfig,
        key: undefined as undefined | string
      }
    }
  },
  beforeRouteEnter(to, from) {
    // 在渲染该组件的对应路由被验证前调用
    // 不能获取组件实例 `this` ！
    // 因为当守卫执行时，组件实例还没被创建！
    fromPath = from.fullPath !== '/' ? from.fullPath : ''
  },
  computed: {
    id() {
      return this.$route.params.id === 'build' ? undefined : this.$route.params.id as string
    },
    isOperating() {
      return this.mainData.$getStatus('operate') === 'ing'
    },
    currentParams() {
      const params = this.$route.params
      return {
        overdueRecordOrFlowId: simpleDecrypt(params.overdueRecordOrFlowId as string),
        flowKey: simpleDecrypt(params.flowKey as string)
      }
    },
    overdueRecordId() {
      if (this.id) {
        if (this.detail) {
          return this.detail.overdueRecordId as string
        } else {
          return undefined
        }
      } else {
        return this.currentParams.overdueRecordOrFlowId as string
      }
    },
    isFinished() {
      if (this.id && this.detail) {
        return this.detail.applyStatus.status !== 'ing'
      } else {
        return false
      }
    }
  },
  watch: {
    id() {
      this.$nextTick(() => {
        this.init()
      })
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.detail = undefined
      const flowEdit = (this.$refs['flow-edit'] as InstanceType<typeof FlowEdit>)
      if (this.id) {
        getFileWithPromise(vehicleApi.vehicleRedeemInfo.require({
          id: this.id
        }), this.id).then(res => {
          const detail = this.mainData.$createDataByDictionary(res.data)
          detail.voucherList = []
          detail.attachmentList = []
          if (res.file) {
            res.file.forEach(item => {
              if (item.data.bizType === 'redeemVoucherFile') {
                detail.voucherList.push(item)
              } else if (item.data.bizType === 'redeemAttachmentFile') {
                detail.attachmentList.push(item)
              }
            })
          }
          this.detail = detail
          this.flow.key = this.currentParams.flowKey as string
          this.getVehicleAmount().finally(() => {
            flowEdit.init(this.flow.key, this.detail)
          })
        })
      } else {
        this.detail = {}
        this.getVehicleAmount().finally(() => {
          flowEdit.init(undefined, this.detail)
        })
      }
    },
    onBack(toFrom?: boolean) {
      if (fromPath && toFrom) {
        // 存在来源路径切需要跳转回来源时，通过back回退
        this.$router.replace(fromPath)
      } else {
        this.$router.replace('/home')
      }
    },
    getVehicleAmount() {
      return new Promise((resolve) => {
        this.detail!.vehicleAmount = []
        promiseAllFinished([vehicleApi.vehicleAmount.require({
          type: '1',
          overdueRecordId: this.overdueRecordId!
        }), vehicleApi.vehicleAmount.require({
          type: '2',
          overdueRecordId: this.overdueRecordId!
        })]).then((resList) => {
          resList.forEach((res, index) => {
            if (res.status === 'success') {
              this.detail!.vehicleAmount[index] = res.data.data.data
            } else {
              this.detail!.vehicleAmount[index] = {}
            }
          })
          resolve(resList)
        })
      })
    }
  }
})
</script>
